import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

import { imageUrlFor } from '../../utils/image-url';
import * as styles from './blog-video-embed.module.css';

interface BlogVideoEmbedProps {
	customThumbnail?: {
		asset: {
			_ref: string;
		};
	};
	url: string;
	videoInstructions?: string;
	className: string;
}

export const BlogVideoEmbed = ({
	customThumbnail,
	url,
	videoInstructions,
	className,
}: BlogVideoEmbedProps) => {
	const [hasHQImage, setHasHQImage] = useState(true);

	const videoId = url.split('v=')[1];

	useEffect(() => {
		const checkImage = () => {
			const img = new Image();

			img.onload = () => {
				if (img.naturalWidth === 120 && img.naturalHeight === 90) {
					setHasHQImage(false);
				}
			};

			img.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
		};

		checkImage();
	}, [videoId]);

	const thumbnailUrl = customThumbnail?.asset
		? imageUrlFor(customThumbnail.asset).url()
		: videoId && hasHQImage
			? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
			: true;

	return (
		<div className={styles.videoEmbedWrapper}>
			{videoInstructions && <p className='heading-xs cdgr'>{videoInstructions}</p>}
			<ReactPlayer
				className={`react-player ${styles.reactPlayerContainer} ${className}`}
				controls
				width='100%'
				light={thumbnailUrl ?? undefined}
				height='auto'
				playing={true}
				url={url}
			/>
		</div>
	);
};
